import React, { Component, ErrorInfo, ReactNode } from 'react';

interface ErrorState {
  hasError: boolean;
  errorCount?: number;
}

interface ErrorPageBoundaryProps {
  name: string;
  errorIsClearable: boolean;
  children: ReactNode | ReactNode[];
}

const MAX_ERRORS = 1;

export default class ErrorMessageBoundary extends Component<ErrorPageBoundaryProps, ErrorState> {
  constructor(props: ErrorPageBoundaryProps) {
    super(props);
    this.state = {
      hasError: false,
      errorCount: 0,
    };
  }

  static getDerivedStateFromError(): ErrorState {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo): void {
    this.setState({ errorCount: this.state.errorCount + 1 });
    console.error(this.props.name, error, errorInfo);
  }

  render(): ReactNode {
    if (this.state.hasError) {
      return (
        <div>
          <div className="message-box">
            <div className="message-icon icon-error" />
            <div className="message-text">
              Något gick fel,{' '}
              {this.props.errorIsClearable && this.state.errorCount <= MAX_ERRORS ? (
                <a href="#" onClick={() => this.setState({ hasError: false })}>
                  försök igen
                </a>
              ) : (
                <a href="#" onClick={() => location.reload()}>
                  ladda om sidan
                </a>
              )}
              .
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}
